import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import { oneAssetApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FundListService = /** @class */ (function () {
    function FundListService(http) {
        this.http = http;
        this._fundListUrl = oneAssetApi + "/Fund/GetList";
        this._body = { FundTypeId: "", FundCode: "" };
    }
    FundListService.prototype.getFundList = function () {
        return this.http.post(this._fundListUrl, this._body);
    };
    FundListService.prototype.getFundList_2 = function () {
        var URL = cmsApi + '/FundOnWeb';
        var body = {};
        return this.http.post(URL, body);
    };
    FundListService.ngInjectableDef = i0.defineInjectable({ factory: function FundListService_Factory() { return new FundListService(i0.inject(i1.HttpClient)); }, token: FundListService, providedIn: "root" });
    return FundListService;
}());
export { FundListService };
